export default __webpack_public_path__ + "static/media/hiven-app-icon.1943f66b.png";